import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Card, CardBody } from "reactstrap";

const CardWidgetSkeleton = () => {
  return (
    <Card className="card-animate">
      <CardBody>
        <div className="d-flex justify-content-between">
          <div>
            <p className="fw-medium text-muted mb-0">
              <Skeleton width={150} height={16} />
            </p>
            <h2 className="mt-4 ff-secondary cfs-22 fw-semibold">
              <Skeleton width={100} height={32} />
            </h2>
            <p className="mb-0 text-muted text-truncate">
              <Skeleton width={120} height={16} />
            </p>
          </div>
          <div>
            <div className="avatar-sm flex-shrink-0">
              <Skeleton circle width={40} height={40} />
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default CardWidgetSkeleton;
